import module from 'finanzas/module.js'

function FinancesPosicionbancariaPrestamoDocumento ($api, $http) {
  this.get = function (idEmpresa, idCuenta, idPrestamo, indice) {
    return $api.link('api/empresa/cuenta/prestamo/documento', {
      id_empresa: idEmpresa,
      id_cuenta: idCuenta,
      id_prestamo: idPrestamo,
      indice: indice,
    })
  }

  this.delete = function (idEmpresa, idCuenta, idPrestamo, indice) {
    return $http.delete('api/empresa/cuenta/prestamo/documento', {
      params: {
        id_empresa: idEmpresa,
        id_cuenta: idCuenta,
        id_prestamo: idPrestamo,
        indice: indice,
      },
    })
  }
}

module.service('FinancesPosicionbancariaPrestamoDocumento', FinancesPosicionbancariaPrestamoDocumento)



// WEBPACK FOOTER //
// ./src/finanzas/services/Finances/Posicionbancaria/Prestamo/Documento.js